export default {
    list: {
        title: "Orders",
        name: 'orders',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: true,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                name: "Actions",
                buttons: [{
                        text: "New order",
                        icon: "add",
                        link: '/orders/new',
                        color: 'primary'
                    },
                    {
                        text: "import orders",
                        icon: "cloud_upload",
                        link: '/orders/import',
                        color: 'primary'
                    },
                ],
            }
        },
        columns: [
            {
                type:"checkbox",
                elements: [{
                   items: [{
                       class: "",
                       type: "checkbox",
                   }, ],
               }, ]
               },
            {
                name: "ID",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "id",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Seller",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "seller",
                        elements: [{
                            items: [{
                                name: "fullName",
                                class: "font-bold text-gray-700",
                                icone: "contacts"
                            },
                            // {
                            //     name: "email",
                            //     class: "font-light text-gray-700",
                            //     icone: "email"
                            // }
                        ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "CUSTOMER",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "customer",
                        elements: [{
                            items: [{
                                    name: "fullName",
                                    class: "font-bold text-gray-700",
                                    icone: "contacts"
                                },
                                {
                                    name: "phone",
                                    class: "font-light text-gray-700",
                                    icone: "phone"
                                }
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "details",
                model: "order",
                title: 'Products'
            },
            {
                name: "Shipping Address",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "customer",
                        elements: [{
                            items: [{
                                name: "shippingAddress",
                            }]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "TOTAL PRICE",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "totalPrice",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Order Date",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "date",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Status",
                class: "",
                elements: [{
                    items: [{
                        class: "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
                        name: "status",
                        data: true,
                        champs: {
                            name: "name",
                            color: "color",
                        },
                    }],
                }, ]
            },
        ],
        columnsDialog: {
            details: 'details',
            elements: [{
                    class: "",
                    name: "Image",
                    referent: "product",
                    items: [{
                        name: "picture",
                    }, ]
                },
                {
                    class: "",
                    name: "sous warehouse",
                    items: [{
                        name: "warehouseParentName",
                    }, ]
                },
                {
                    class: "",
                    name: "Name",
                    referent: "product",
                    items: [{
                        name: "name",
                    }, ]
                },
                {
                    class: "",
                    name: "Id",
                    referent: "product",
                    items: [{
                        name: "id",
                    }, ]
                },
                {
                    class: "",
                    name: "Unit price",
                    items: [{
                        name: "unitPrice",
                    }, ]
                },
                {
                    class: "",
                    name: "Quantity",
                    items: [{
                        name: "quantity",
                    }, ]
                },
            ]
        },
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [
                {
                    icone: "filter_1",
                    color: "success",
                    role: true,
                    key: 'double',
                    tooltip: "Double",
                },
                {
                    icone: "remove_red_eye",
                    color: "success",
                    key: 'read',
                    id: "",
                    role: true,
                    link: '/orders/detail',
                    tooltip: "Update",
                },
                {
                    icone: "edit",
                    color: "success",
                    role: true,
                    key: 'update',
                    link: '/orders/edit',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'orders',
            hasFilterdate:true,
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "ID, Custumer name, Custumer phone, Shipping Address, Total price ...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    },
                    dropdowns:{
                        value: {key: "idOrder",name: "Order ID"},
                        values: [
                            {
                                key: "idOrder",
                                name: "Order ID",  
                            },
                            {
                                key: "customer.phone",
                                name: "Customer phone",  
                            },
                            {
                                key: "customer.fullName",
                                name: "Customer name",  
                            }
                        ]
                    }
                },
                champs: [
                    {
                        label: "Status",
                        key: "status",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },

                    {
                        label: "pending status",
                        key: "status_pending",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },

                    {
                        label: "Nombre des appels",
                        key: "range_numbers",
                        name: "",
                        value: {min:0,max:0},
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "range_numbers",
                    },
                    
                    {
                        label: "Seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Product",
                        key: "product",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                   
                    {
                        label: "Phone",
                        key: "phone",
                        value: null,
                        placeholder: "phone",
                        type: "number",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                    {
                        label: "Action date Range",
                        key: "Range_updatedAt",
                        value: null,
                        placeholder: "Action date Range ...",
                        type: "date_range",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                    {
                        label: "Date Range",
                        key: "Range_date",
                        value: null,
                        placeholder: "Date Range ...",
                        type: "date_range",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                ],
            },
        },
    },
}
